import { useMemoizedFn } from "ahooks";
import { useShellRouter } from "@hooks/useShellAwareRouter";
import { useSnapshot } from "valtio";
import { redirectToLoginPage } from "@features/login/redirectToLoginPage";
import { ROUTER_PATH } from "@config/router";
import { rootStore } from "@store/rootStore";
// import { pubSubKeyMap } from "../utils/pubSubKeyMap";
// import { pubsub } from "utils";
import { usePathname } from "@hooks/usePathname";
// import { useEffect, useState } from "react";

export const TabkeyMap = {
  quests: "quests",
  referral: "referral",
  rebate: "rebate",
  tweets: "tweets",
} as const;

interface UseNavigateToAuraOptions {
  onClose?: () => void;
  // goToAuraAfterLogin?: boolean;
}

export const AURA_FORM_SOURCE_BACK_TO_HOME = "root";

export interface NavigateToAuraParams {
  fromSource?: string;
}

export const useNavigateToAura = (options: UseNavigateToAuraOptions = {}) => {
  const { onClose } = options;
  const router = useShellRouter();
  const pathname = usePathname(true);
  const { isLoggedIn } = useSnapshot(rootStore.login);
  const { ownerInfo } = useSnapshot(rootStore.user);
  // const { open: openCreateProfileModal } = useCreateProfileModalProvider();
  // const [fromSource, setFromSource] = useState<string | undefined>(undefined);
  const navigateToAura = useMemoizedFn(
    async (params?: NavigateToAuraParams) => {
      // 先关闭当前弹窗/菜单
      onClose?.();
      // 如果没有传递 fromSource，自动从当前路由提取
      const currentFromSource = params?.fromSource || pathname;
      // 如果用户已登录 直接跳转aura页面
      if (ownerInfo?.id) {
        const url = `${ROUTER_PATH.AURA_PROFILE}/${ownerInfo?.id}?from=${currentFromSource}&tabkey=${TabkeyMap.quests}`;
        router.push(url);
        return;
      }
      // setFromSource(currentFromSource);
      // 如果用户未登录，打开登录弹窗
      redirectToLoginPage();
    },
  );

  const navigateToAuraRebate = useMemoizedFn(
    async (params?: NavigateToAuraParams) => {
      // 先关闭当前弹窗/菜单
      onClose?.();
      // 如果没有传递 fromSource，自动从当前路由提取
      const currentFromSource = params?.fromSource || pathname;
      // 如果用户已登录 直接跳转aura页面
      if (ownerInfo?.id) {
        const url = `${ROUTER_PATH.AURA_PROFILE}/${ownerInfo?.id}?from=${currentFromSource}&tabkey=${TabkeyMap.rebate}`;
        router.push(url);
        return;
      }
      // setFromSource(currentFromSource);
      // 如果用户未登录，打开登录弹窗
      redirectToLoginPage();
    },
  );

  // useEffect(() => {
  //   if (goToAuraAfterLogin) {
  //     const cleanup = { off: undefined as (() => void) | undefined };

  //     const handleLoginSuccess = async () => {
  //       const latestOwnerInfo = rootStore.user.ownerInfo;
  //       if (!latestOwnerInfo?.id) {
  //         return;
  //       }
  //       // 先取消监听，确保只执行一次
  //       cleanup.off?.();
  //       // 登录成功后重新获取最新的用户信息构建 URL
  //       const loginSuccessUrl = `${ROUTER_PATH.AURA_PROFILE}/${latestOwnerInfo?.id}?from=${fromSource}`;
  //       router.push(loginSuccessUrl);
  //     };

  //     cleanup.off = pubsub?.on(pubSubKeyMap.LOGIN_SUCCESS, handleLoginSuccess);

  //     return () => {
  //       cleanup.off?.();
  //     };
  //   }
  // }, [isLoggedIn, router, fromSource, goToAuraAfterLogin]);
  return {
    /** 导航到Aura页面的函数 */
    navigateToAura,
    navigateToAuraRebate,
    /** 是否可以直接导航（用户已登录） */
    canNavigateDirectly: !!ownerInfo?.id,
    /** 是否需要登录 */
    needsLogin: !isLoggedIn,
  };
};
